import PageHeader from "../components/PageHeader";
import FormFrame from "../components/FormFrame";
import EditorialMarquee from "../components/EditorialMarquee";
import { Reveal } from "../components/Reveal";
import { IMAGES, GHL_FORMS } from "../data/site";
import { CalendarCheck, Clock, Sparkles } from "lucide-react";

const STEPS = [
  { icon: CalendarCheck, t: "Pick a time", d: "Choose a date and time that works for you." },
  { icon: Sparkles, t: "Walk the hall", d: "Experience the ballroom, chandeliers & spaces first-hand." },
  { icon: Clock, t: "Plan together", d: "Discuss packages, catering and available dates on the spot." },
];

export default function Tour() {
  return (
    <div data-testid="tour-page">
      <PageHeader
        overline="Private Venue Tour"
        titleLines={["Schedule Your", <span key="i" className="italic text-gold">Private Tour</span>]}
        subtitle="Experience Vista Banquet Hall in person. Schedule a private tour and discover the perfect space for your wedding, celebration, or special event."
        image={IMAGES.ceremony}
        imageAlt="Vista Banquet Hall ceremony setup"
        testId="tour-header"
      />

      {/* imagery strip */}
      <section className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid grid-cols-3 gap-4">
          {[IMAGES.venueBallroom, IMAGES.floralArch, IMAGES.chandelier].map((src, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="aspect-[4/5] overflow-hidden rounded-sm border border-gold/25">
                <img src={src} alt="Vista Banquet Hall interior" className="h-full w-full object-cover" />
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-32">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="overline text-gold">How It Works</span>
              <h2 className="mt-5 font-serif text-3xl md:text-4xl font-light tracking-tight text-navy">
                Three simple steps to your visit.
              </h2>
            </Reveal>
            <div className="mt-10 space-y-8">
              {STEPS.map((s, i) => (
                <Reveal key={i} delay={i * 0.1}>
                  <div className="flex items-start gap-5">
                    <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-gold/50 text-gold">
                      <s.icon size={20} />
                    </span>
                    <div>
                      <h3 className="font-serif text-2xl font-light text-navy">{s.t}</h3>
                      <p className="mt-1 text-navy/60 font-light">{s.d}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <FormFrame
              overline="Appointment Form"
              title="Book Your Tour"
              subtitle="Select a date & time below — we'll confirm right away."
              formId={GHL_FORMS.tour.id}
              formName={GHL_FORMS.tour.name}
              height={GHL_FORMS.tour.height}
              testId="tour-form"
            />
          </div>
        </div>
      </section>

      <EditorialMarquee items={["Schedule a Tour", "Visit Vista", "Alexandria, Virginia", "Book Your Date"]} dark />
    </div>
  );
}
